import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";

export class QueuePollRequestFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.clear();
  }

  idChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get id():any {
    return this.idChange.value;
  }
  set id(id:any) {

    this.idChange.next(id);
    this.emitChange("id", id);
  }

  errorChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get error():any {
    return this.errorChange.value;
  }
  set error(error:any) {

    this.errorChange.next(error);
    this.emitChange("error", error);
  }

  userIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get userId():any {
    return this.userIdChange.value;
  }
  set userId(userId:any) {

    this.userIdChange.next(userId);
    this.emitChange("userId", userId);
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(companyId:any) {

    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  queueCarrierIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get queueCarrierId():any {
    return this.queueCarrierIdChange.value;
  }
  set queueCarrierId(queueCarrierId:any) {

    this.queueCarrierIdChange.next(queueCarrierId);
    this.emitChange("queueCarrierId", queueCarrierId);
  }

  queueNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get queueName():any {
    return this.queueNameChange.value;
  }
  set queueName(queueName:any) {

    this.queueNameChange.next(queueName);
    this.emitChange("queueName", queueName);
  }

  datetimeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get datetime():any {
    return this.datetimeChange.value;
  }
  set datetime(datetime:any) {

    this.datetimeChange.next(datetime);
    this.emitChange("datetime", datetime);
  }

  errorDetailChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get errorDetail():any {
    return this.errorDetailChange.value;
  }
  set errorDetail(errorDetail:any) {

    this.errorDetailChange.next(errorDetail);
    this.emitChange("errorDetail", errorDetail);
  }

  queueCarrierNameChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get queueCarrierName():any {
    return this.queueCarrierNameChange.value;
  }
  set queueCarrierName(queueCarrierName:any) {

    this.queueCarrierNameChange.next(queueCarrierName);
    this.emitChange("queueCarrierName", queueCarrierName);
  }


  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.id && this.id !== '') {
      params = params.set("id", this.id);
    }

    if (this.error && this.error !== '') {
      params = params.set("error", this.error);
    }

    if (this.userId && this.userId !== '') {
      params = params.set("userId", this.userId);
    }

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }

    if (this.queueCarrierId && this.queueCarrierId !== '') {
      params = params.set("queueCarrierId", this.queueCarrierId);
    }

    if (this.queueName && this.queueName !== '') {
      params = params.set("queueName", this.queueName);
    }

    if (this.datetime && this.datetime !== '') {
      params = params.set("datetime", this.datetime);
    }

    if (this.errorDetail && this.errorDetail !== '') {
      params = params.set("errorDetail", this.errorDetail);
    }

    if (this.queueCarrierName && this.queueCarrierName !== '') {
      params = params.set("queueCarrierName", this.queueCarrierName);
    }


    return params;
  }

  public clear():void {

    this.id = undefined;
    this.error = undefined;
    this.userId = undefined;
    this.companyId = undefined;
    this.queueCarrierId = undefined;
    this.queueName = undefined;
    this.datetime = undefined;
    this.errorDetail = undefined;
    this.queueCarrierName = undefined;

  }
}
